import { IMapPosition, POSITION_TYPE, WithId } from 'transfix-maps/types'

/**
 * Returns a default value for position type based on values
 * @example getSelectedPositionType(position, 0, '123') // POSITION_TYPE.LAST_PING
 */
export function getSelectedPositionType<TPosition extends WithId<IMapPosition>>(
  position: TPosition,
  index: number,
  selectedPositionId: string | number
): POSITION_TYPE {
  if (index === 0 && position?.data?.id === selectedPositionId) {
    return POSITION_TYPE.LAST_PING_SELECTED
  }

  if (index === 0) {
    return POSITION_TYPE.LAST_PING
  }

  if (position?.data?.id === selectedPositionId) {
    return POSITION_TYPE.PREVIOUS_PING_SELECTED
  }

  return POSITION_TYPE.PING
}
